import classNames from "classnames";
import { styled } from "@linaria/react";
import React from "react";
import { color, easingBounce, easingBounceMs } from "..";

const Wrapper = styled.div`
  color: ${color.carbon900};
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  cursor: pointer;
  white-space: nowrap;
`;

const Text = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 16px;
  flex: none;
`;

const Content = styled.div`
  margin-top: 8px;
  :not(.opened) {
    display: none;
  }
`;

const CheckMark = styled.div`
  position: relative;
  ::after {
    content: "";
    position: absolute;
    width: 0.5em;
    height: 0.5em;
    border-width: 0 2px 2px 0;
    border-style: solid;
    border-color: ${color.carbon900};
    transition: transform ${easingBounceMs}ms ${easingBounce};
    transform-origin: 60% 60%;
    top: -10px;
    right: 4px;
  }
  &:not(.opened)::after {
    transform: rotate(135deg);
  }
  &.opened::after {
    transform: rotate(45deg);
  }
`;

export interface P extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title: React.ReactNode;
  onToggle: () => void;
  opened: boolean;
  disabled?: boolean;
}

const Collapse = ({ title, children, onToggle, opened, disabled, ...props }: P) => (
  <Wrapper {...props}>
    <Title onClick={onToggle} className={classNames({ disabled })}>
      <Text>{title}</Text>
      {disabled ? null : <CheckMark className={classNames({ opened })} />}
    </Title>
    <Content className={classNames({ opened })}>{children}</Content>
  </Wrapper>
);

export default Collapse;
